import React, { useState, useEffect } from 'react';

// 예시
function useViewport(): { viewWidth: number; viewHeight: number } {
  const [width, setWidth] = useState(window.innerWidth);
  const [height, setHeight] = useState(window.innerHeight);

  useEffect(() => {
    function onResize() {
      if (typeof window.innerWidth != 'undefined') {
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
      } else {
        setWidth(document.documentElement.clientWidth);
        setHeight(document.documentElement.clientHeight);
      }
    }

    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return { viewWidth: width, viewHeight: height };
}

export default useViewport;
